import {firstName, lastName} from '../field-templates/names/names';
import {email, phone} from '../field-templates/contact-info/contactInfo';
import {address1, address2, city, state, zip, country} from '../field-templates/address/address';
import {buildField} from '../field-templates/fieldBuilder';

export default {
    groups: [
        {
            styleClasses: "row",
            fields: [buildField(firstName), buildField(lastName)],
        },
        {
            styleClasses: "row",
            fields: [buildField(email), buildField(phone)]
        },
        {
            styleClasses: "row",
            fields: [buildField(address1)]
        },
        {
            styleClasses: "row",
            fields: [buildField(address2)]
        },
        {
            styleClasses: "row",
            fields: [buildField(city), buildField(state), buildField(zip), buildField(country)]
        },
    ]
}
